import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
function disableConsole(): void {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.warn = () => {};
  console.error = () => {};
}

if (environment.production || environment.staging) {
  disableConsole();
}
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
